import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import "./ResponseModal.css";

export default function ResponseModal(props) {
  const {
    message, toggleModal, handleDelete, missingTestErrors,
  } = props;
  const success = !message.startsWith("Duplicates");
  return (
    <div>
      <SweetAlert
        confirmBtnBsStyle="btn-hide"
        onConfirm={() => {}}
        title=""
        onCancel={() => {}}
      >
        <div className="MigrateModal__Container">
          <div className="MigrateModalMessage">
            {message}
            {" "}
          </div>
          {missingTestErrors.length > 0 && (
          <div className="MigrateModal__MissingTestErrorsContainer">
            {missingTestErrors.map((item, index) => (
              <div key={index} className="MigrateModal__MissingTestErrorsItem">
                <span>{`${index + 1}.`}</span>
                <span>{item}</span>
              </div>
            ))}
          </div>
          )}
          <button type="button" className="migrateBtn" onClick={success ? toggleModal : handleDelete}>
            {success ? "Close" : "Delete Duplicates"}
          </button>
        </div>
      </SweetAlert>
    </div>
  );
}
